import React from 'react';

const Now = () => {
  return (
    <span className='w-[47px] h-[19px] bg-primary-DA_Red rounded-[10px] text-white text-[11px] font-bold'>NOW</span>
  );
};
export default Now;
